module.exports = __webpack_public_path__ + "img/logo.0975ba8e.png";